import dynamic from 'next/dynamic'
import { useAdminCookie } from '../../contexts'
import { IEditAssetProps } from './EditAsset'

export const OttEditMe = (props: IEditAssetProps) => {
  const admin_cookie = useAdminCookie()
  if (admin_cookie) {
    const EditAsset = dynamic(() => import('./EditAsset'), { ssr: false })
    return <EditAsset {...props} />
  }
  return null
}
